import './public-path'
// import 'babel-polyfill'
import Vue from 'vue'
import routes from './router'
import store from './store'
import VueRouter from 'vue-router'
import App from './App.vue'
import '@/assets/mixins'
import importDirective from '@/assets/directive'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import * as filters from '@/assets/filters' // global filters

import '@/components/privacy' // 引入隐私协议
import '@/components/invite' // 引入邀请员工加入企业
import zjyUI from '@zjy/zjy-ui/lib/index'
import '@zjy/zjy-ui/lib/theme-chalk/index.min.css'
import '@zjy/zjy-ui/packages/tree/src/style/tree.css'
// import locale from '@zjy/zjy-ui/lib/locale/lang/en'
import animated from 'animate.css'
import Promise from 'promise-polyfill'

import Common from '@/assets/js/commonFunctions'
import Notifications from 'vue-notification'
import {i18n} from '@/assets/setup/i18n-setup'
// import microApps from '@/micro-app'
// import {registerMicroApp} from '@/assets/utils/micro' // 主服务---集成一冶
import MicroAppStore from '@/assets/utils/microApp' // 微服务---被集成到xmgl平台
import {Tooltip} from 'element-ui'
import 'element-ui/lib/theme-chalk/tooltip.css'
import { setCookie, getCookie } from '@/assets/utils/CommonUtil'


// 实际打包时应该不引入mock
// if (process.env.NODE_ENV !== 'production') require('@/assets/mock')

window.common = new Common()

if (!window.Promise) {
  window.Promise = Promise
}

Vue.use(Tooltip)
Vue.use(Notifications)
Vue.use(animated)
Vue.use(zjyUI, {watchDialogVisible: true})
// Vue.use(zjyUI, {locale})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// Vue.config.devtools = false;
Vue.config.productionTip = false
importDirective(Vue)

let router = null
let instance = null

// Vue 根实例的 $data
const rootState = {
  orgId: null, // 门户当前组织
  IDorgType: '', // 门户当前组织类型
  orgFullId: '', // 门户当前组织的
  fullIdmoduleCode: '', // 模块编码，用于界面中的权限控制
  authorityCodes: '', // 模块权限项，用于界面中的权限控制
  isI18nEnv: false, // 当前版本是否为国际化环境
  userId: '', // 可选; 当前用户ID
  tenantId: null, // 可选; 当前租户ID
  refresh: false // 可选; 仅在实例化 new MicroAppStore(props, { selfRefresh: true}) 时配置为true才有效，具体参考下文中的 initStore()
}

function render (props = {}) {
  const { container, baseUrl } = props
  router = new VueRouter({
    base: window.__POWERED_BY_QIANKUN__ ? baseUrl : process.env.BASE_URL,
    mode: 'hash',
    routes
  })

  instance = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app')
  // registerMicroApp(instance, microApps) // 主服务---一冶使用
}

// export const instance = new Vue({
//   router,
//   store,
//   i18n,
//   render: h => h(App)
// }).$mount('#app')

// registerMicroApp(instance, microApps)

// 独立运行环境
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

// 初始化微应用状态管理，实现与门户之间的通信
function initStore (props) {
  const options = {
    selfRefresh: false // 当门户上下文变更时，是否自行实现数据刷新；默认是 false 门户会强行刷新子应用
  }
  const microAppStore = new MicroAppStore(props, options)

  // 可选：便于在组件中使用 store.setState() 方法设置门户全局状态，如：this.$microAppStore.setState({ lang: 'zh-CN' })
  Vue.prototype.$microAppStore = microAppStore // 按需使用
  // 获取全局状态：
  // microAppStore.state // state对象包含所有的全局状态

  // 一、绑定状态变更事件
  microAppStore.toBindStateChange({ rootState }, async (value, prev) => {
    // console.log(value, prev)

    const {token, accountName, orgName, orgId, isAsideExpand, authorityCodes} = value
    store.commit('menus/SET_IS_ASIDE_EXPAND', isAsideExpand)
    value.ZJYTOKEN = token
    value.userName = accountName
    value.companyName = orgName
    value.orgId = orgId

    store.commit('menus/SET_NAV_BAR', true)
    store.commit('menus/SET_HIDE_LEFT_MENUS', true)
    store.commit('menus/SET_IS_MICRO', true)
    const GEIPTOKEN = getCookie('GEIPTOKEN')
    if (window.self !== window.top){
      if (!GEIPTOKEN){
        setCookie('ZJYTOKEN', token)
        setCookie('GEIPTOKEN', token)
      }
    } else {
      setCookie('ZJYTOKEN', token)
      setCookie('GEIPTOKEN', token)
    }
    const res = await store.dispatch('user/getUserInfo')
    const {gldUserId, gldToken, enterpriseId: entId} = res.data
    value.gldUserId = gldUserId || ''
    value.gldToken = gldToken || ''
    value.entId = entId || ''
    setCookie('gldUserId', gldUserId)
    setCookie('gldToken', gldToken)
    setCookie('entId', entId)
    setCookie('geipOrgIdValue', orgId)
    setCookie('ZJYUSERINFO', JSON.stringify({gldUserId,userName:accountName,companyName:orgName,authorityCodes}))

    store.commit('user/SET_USERINFO', value)
    window.ZJYUSERINFO = JSON.stringify(value)
  })
}

// bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
export async function bootstrap () {
  // 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
}

// 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
export async function mount (props) {
  initStore(props)

  Vue.prototype.$microAppRouter = props.microAppRouter // 可选：需要跳转到其它微应用时使用
  Vue.prototype.$openWindow = props.openWindow // 可选：在新窗口打开微应用

  render(props)
}

// 应用每次切出/卸载会调用的方法，通常在这里我们会卸载微应用的应用实例
export async function unmount () {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}
